/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.posConfig',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.service.userPreferences',
  'acme.view.application.pos.create.modals.controllers'
])
.value('POS_CREATE_STRINGS', {
  LOCALE: {
    'E_ERROR_WHILE_SAVING': 'An error has occurred while saving'
  }
})
.controller('PosCreateController', [
  '$scope',
  '$state',
  '$location',
  '$filter',
  '$timeout',
  '$uibModal',
  'POS_CREATE_STRINGS',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'PosConfigService',
  'ValidateService',
  'PermissionsService',
  'NoticeFactory',
  'UserPreferencesService',
  function($scope,
           $state,
           $location,
           $filter,
           $timeout,
           $uibModal,
           POS_CREATE_STRINGS,
           ApiService,
           CalendarService,
           HelpersService,
           PosConfigService,
           ValidateService,
           PermissionsService,
           NoticeFactory,
           UserPreferencesService) {

  $scope.posCreate = {

    model: {
      name: ''
    },

    mode: 'create',
    publishDate: false,
    draftDate: false,

    validators: [],

    cap: HelpersService.cap,
    notice: new NoticeFactory(),

    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

    init: function() {

      ValidateService.errors = [];

      this.initValidators();

      if ($state.params && $state.params.configId) {
        this.mode = 'edit';
        this.getConfig($state.params.configId);
      }else{
        PosConfigService.options.setModel(this.model);
      }

      $scope.$emit('Application::contentTitleChange', {
        title: HelpersService.cap(this.mode) + ' Point of Sale Configuration',

        buttonRight: {
          label: this.isMode('edit') ? 'Save' : 'Create',
          permissions: 'WL_POS_CONFIG_VIEW',
          action: function() {
            $scope.posCreate.save(false, true);
          }
        },

        buttonLeft: {
          label: '< Back',
          permissions: 'WL_POS_CONFIG_VIEW',
          action: function() {
            $scope.posCreate.cancel();
          }
        }

      });

      $scope.$on('PosCreatePagesController::Update', function() {
        $scope.posCreate.save(false, true, false, true);
      });

      $scope.$on('PosCreateImagesController::Update', function() {
        $scope.posCreate.save(false, true, false, true);
      });
      
      $scope.$on('$destroy', function () {
        PosConfigService.reset();
      });

    },

    initValidators: function() {
      this.validators = [
        {
          field: 'pos-header-name',
          len: {
            message: 'The configuration name must not be empty',
            test: function() {
              var self = $scope.posCreate;
              return {
                value: self.model.name
              };
            }
          }
        }
      ];
    },

    getError: function(field) {
      return ValidateService.getError(field);
    },

    getConfig: function(id) {
      ApiService.pos.detail(id).then(this.success.getConfig, this.error.getConfig);
    },

    setUpdateTimes: function(posConfig) {
      if (posConfig && posConfig.status) {
        if (posConfig.status.draftDate) {
          this.draftDate = $filter('date')(CalendarService.parseDate(posConfig.status.draftDate), this.dateTimeFormat);
        }
        if (posConfig.status.publishDate) {
          this.publishDate = $filter('date')(CalendarService.parseDate(posConfig.status.publishDate), this.dateTimeFormat);
        }
      }
    },

    isState: function (path) {

      var location = $location.path();

      return (location.indexOf(path) !== -1);

    },
    
    isMode: function (mode) {
      return (this.mode === mode);
    },
    
    getState: function (name) {
      var stateName = 'application.pos',
          stateParams = {};

      if (this.mode === 'create') {
        stateName += '.create.'+name;
      }else{
        stateName += '.edit.'+name;
        stateParams.configId = $state.params.configId;
      }

      this.save(false, true, {
        name: stateName,
        stateParams: stateParams
      });
    },

    cancel: function() {
      $state.go('application.pos.list');
    },

    remove: function() {
      var self = $scope.posCreate;

      self.modalDialog = $uibModal.open( {
        templateUrl: 'views/application/views/pos/modals/posDeleteModal.tpl.html',
        size: 'md',
        controller: 'PosDeleteModalController',
        resolve: {
          listItem : self.model,
          terminals: self.model.configId ? ApiService.terminals.config.list(self.model.configId) : [],
          allow: !self.model.assigned
        }
      });

      self.modalDialog.result.then( function() {
          ApiService.pos.remove(self.model.configId).then(function(response) {
            self.cancel();
          });
      }, function() {
        // do nothing});
      });

    },

    publish: function() {
      this.showPublishNotification(this.model);
    },

    save: function (publish, update, state, silent) {
      var self = $scope.posCreate,
          name = this.model.name;
      
      this.isUpdate = (update);
      this.isSaving = true;
      this.isSubmitted = true;

      this.notice.hideErrorMessages();
      this.notice.hideSuccessMessages();

      // Trigger save event downstream to subviews
      if (!silent) {
        $scope.$broadcast('PosCreateController::Save');
      }

      //next tick
      $timeout(function() {
        var config;

        if (ValidateService.errors.length === 0 && ValidateService.validate(self.validators) ) {
          config = PosConfigService.getConfig(true);
          config.name = name;

          if (self.isMode('edit')) {
            if (publish) {
              ApiService.pos.update(config, publish).then(function(response) {
                self.success.save(response);

                if (state) {
                  $state.go(state.name);
                }
              }, self.error.save);
            } else {
              ApiService.pos.update(config).then(function(response) {
                self.success.save(response);
                if (state) {
                  $state.go(state.name);
                }
              }, self.error.save);
            }
          }else {
            ApiService.pos.create(config).then(function(response) {
              var stateName = 'application.pos.edit.description';

              if (state && state.name) {
                stateName = state.name.replace('create', 'edit');
              }

              self.success.save(response);

              $state.go(stateName, { configId: response.data.payload.configId }, { notify: true });

            }, self.error.save);
          }
        } else {
          self.isSaving = false;
          self.isSubmitted = false;
          self.isUpdate = false;
        }
      }, 0);
    },
    
    hasTabErrors: function () {
      return false;
    },
    
    showPublishNotification: function (config) {
      var self = $scope.posCreate;

      self.modalDialog = $uibModal.open( {
        templateUrl: 'views/application/views/pos/create/modals/posPublishModal.tpl.html',
        size: 'md',
        controller: 'PosPublishModalController',
        resolve: {
          terminals: function() {
            var r = [];

            if (config.configId) {
              r = ApiService.terminals.config.list(config.configId);
            }

            return r;
          },
          emptyPages: function() {
            return PosConfigService.pages.getEmptyPages();
          }
        }
      });

      self.modalDialog.result.then( function() {
        self.save(true, true, { name: 'application.pos.list' });
      }, function() {
        // do nothing
      });
    },
    
    success: {
      init: function(response) {},
      save: function(response) {
        var self = $scope.posCreate;

        self.isSaving = false;
        self.isUpdate = false;
        self.isSubmitted = false;

        self.setUpdateTimes(response.data.payload);
      },

      getConfig: function(response) {
        var self = $scope.posCreate;

        PosConfigService.setConfig(response.data.payload);

        self.model = PosConfigService.options.getModel();
        $scope.$broadcast('PosCreateController::UpdateModel');

        self.setUpdateTimes(response.data.payload);
      }
    },

    error: {
      init: function(response) {},
      save: function(response) {
        var message = POS_CREATE_STRINGS.LOCALE.E_ERROR_WHILE_SAVING,
            self = $scope.posCreate;

        self.isSaving = false;
        self.isUpdate = false;
        self.isSubmitted = false;

        if (response && response.data && response.data.error) {
          message = response.data.error;
        }
        self.notice.showErrorMessages([{
          message: message
        }]);
      },
      getConfig: function(response) {}
    }

  };

  $scope.posCreate.init();

}]);